import React from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import {ICON_NAMES} from '@nur-portal/ui-kit';

const TrendCard = ({
  className,
  id,
  date,
  url,
  title,
  contentPreview,
  formattedDate
}) => {
  const {t} = useTranslation();

  return (
    <article data-id={id} className={clsx(['trend-card', 'js-article', className])}>
      <time className="trend-card__date" dateTime={date}>
        {formattedDate}
      </time>
      <div className="card-meta trend-card__count-block">
        <div className="card-meta__item js-article-preview-comments hidden">
          <svg className="card-meta__icon">
            <use href={`#${ICON_NAMES.COMMENTS_18}`} />
          </svg>
          <div className="card-meta__text js-article-preview-comments-count" />
        </div>
        <div className="card-meta__item js-article-preview-reactions hidden">
          <svg className="card-meta__icon">
            <use href={`#${ICON_NAMES.REACTIONS_18}`} />
          </svg>
          <div className="card-meta__text js-article-preview-reactions-count" />
        </div>
      </div>
      <a className="trend-card__title" href={url}>
        {title}
      </a>
      <p className="trend-card__description">{contentPreview}</p>
      <a
        className="button button--outline button--icon-right trend-card__read-more-link"
        href={url}
      >
        <svg className="button__icon">
          <use href={`#${ICON_NAMES.ARROW_RIGHT_20}`} />
        </svg>
        {t('readArticle')}
      </a>
    </article>
  );
};

export {TrendCard};
